import {combineReducers} from 'redux'
import types from 'actions/types'

export const isUpdating = (state = false, action) => {
  switch (action.type) {
    case types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_ATTEMPT:
      return true
    case types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_SUCCESS:
      return false
    case types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_FAILURE:
      return false
    default:
      return state
  }
}

export const quickBooksStatus = (state = null, action) => {
  switch (action.type) {
    case types.QUICK_BOOKS_STATUS_SUCCESS:
      return action.data
    case types.QUICK_BOOKS_UPDATE_ACCOUNT_DATA_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  isUpdating,
  quickBooksStatus,
})
